<template>
  <div>
    <Modal title="Title" v-model="showFormModal" class-name="card-modal" :width="action=='view'?400:900">
      <div slot="header">
        <h4>{{title}}</h4>
      </div>

      <table width="100%">
        <tr>
          <td width="50%" align="right">Company Name:</td>
          <td width="3%">
            <Divider type="vertical"/>
          </td>
          <td width="47%" align="left"><h3>{{companyName}}</h3></td>
        </tr>
        <tr>
          <td width="50%" align="right">
            <Page :total="dataCompanyCount" :page-size="pageCompanySize"
                  show-total show-sizer :page-size-opts="pageCompanySizer" transfer
                  @on-change="changeSelectedCompanyPage" @on-page-size-change="changeCompanyPageSize">
            </Page>
          </td>
          <td width="3%">
            <Divider type="vertical"/>
          </td>
          <td width="47%" align="left">
            Include expired licenses &nbsp
            <i-switch v-model="showAllLicences" @on-change="setFormValue(companyId)"></i-switch>
          </td>
        </tr>
      </table>

      <Form ref="companyLicenseForm" :model="companyLicenseForm"
            :rules="ruleValidate" label-wdith="10" label-position="left">
        <Spin size="large" fix v-show="spinnerShowLicense"></Spin>
        <FormItem>
          <i-col :xs="2" :sm="2" :md="2" :lg="2" style="text-align: left">
            <div class='full-input'>
              <label class="label-answer">
                <b><i>Is Used</i></b>
              </label>
            </div>
          </i-col>
          <i-col :xs="2" :sm="2" :md="2" :lg="2" style="text-align: left">
            <div class='full-input'>
              <label class="label-answer">
                <b><i>Device</i></b>
              </label>
            </div>
          </i-col>
          <i-col :xs="6" :sm="6" :md="6" :lg="6" style="text-align: left">
            <div class='full-input'>
              <label class="label-answer">
                <span class="red-star">★</span>
                <b><i>Label</i></b>
              </label>
            </div>
          </i-col>
          <i-col :xs="4" :sm="4" :md="4" :lg="4" style="text-align: left">
            <div class='full-input'>
              <label class="label-answer">
                <span class="red-star">★</span>
                <b><i>Key</i></b>
              </label>
            </div>
          </i-col>
          <i-col :xs="4" :sm="4" :md="4" :lg="4" style="text-align: left">
            <div class='full-input'>
              <label class="label-answer">
                <span class="red-star">★</span>
                <b><i>Events</i></b>
              </label>
            </div>
          </i-col>
          <i-col :xs="4" :sm="4" :md="4" :lg="4" style="text-align: left">
            <div class='full-input'>
              <label class="label-answer">
                <span class="red-star">★</span>
                <b><i>Expiry Date</i></b>
              </label>
            </div>
          </i-col>
          <i-col :xs="2" :sm="2" :md="2" :lg="2" style="text-align: center">
            <div class='full-input'>
              <label class="label-answer" style="text-align: center">
                <b><i>Actions</i></b>
              </label>
            </div>
          </i-col>
        </FormItem>
        <FormItem v-for="(licenseItem, ix) in companyLicenseForm.items" :key="ix">
          <i-col :xs="2" :sm="2" :md="2" :lg="2" style="text-align: left">
            <div class='full-input'>
              <Icon v-show="licenseItem.isUsed" title="Force Log Out"
                    type="ios-checkmark" size="24"
                    class="greenMark" @click="openLogOut(ix)"/>

              <Icon v-show="!licenseItem.isUsed" title=""
                    type="md-close" size="24" class="grayMark"/>
            </div>
          </i-col>
          <i-col :xs="2" :sm="2" :md="2" :lg="2" style="text-align: left">
            <div v-show="licenseItem.isUsed">
              <Icon v-if="licenseItem.deviceType == 'ios'" class="ico" type="logo-apple"
                    title="Being used by an ios" size="24"/>

              <Icon v-if="licenseItem.deviceType == 'android'" class="ico" type="logo-android"
                    title="Being used by an android" size="24"/>

              <Icon v-if="licenseItem.deviceType == null || licenseItem.deviceType == 'desktop'"
                    class="ico" type="ios-laptop" title="Being used by desktop" size="24"/>
            </div>
            <div v-show="!licenseItem.isUsed">
              <Icon v-if="(licenseItem.deviceType == null || licenseItem.deviceType == '')"
                    style="color: #9b3035" type="ios-laptop" size="24"/>
            </div>
          </i-col>
          <i-col :xs="6" :sm="6" :md="6" :lg="6" style="text-align: left">
            <div class='full-input'>
              <FormItem class="licLabel"
                        :prop="'items[' + ix + '].licenseLabel'"
                        :rules="{required: true, message: 'Label cannot be empty', trigger: 'blur'}">
                <Input v-model="licenseItem.licenseLabel" class="label-answer" type="text"
                       @on-change="(e) => licenseLabelCheck(e, ix)">
                </Input>
              </FormItem>
            </div>
          </i-col>
          <i-col :xs="4" :sm="4" :md="4" :lg="4" style="text-align: left">
            <div class='full-input'>
              <Label v-model="licenseItem.licenseKey" class="label-answer" type="text">
                {{licenseItem.licenseKey}}
              </Label>
            </div>
          </i-col>
          <i-col :xs="4" :sm="4" :md="4" :lg="4" style="text-align: left">
            <FormItem>
              <AutoComplete clearable placeholder="Input Event Name"
                            size="small" :data="eventList" :filter-method="filterMethod"
                            v-model="eventNames[ix]"
                            icon="ios-search" @on-change="(e) => changeEvents(ix, e)" transfer>
              </AutoComplete>
              <!--<Select v-model = "licenseItem.eventId" @on-change = "(e) => changeEvents(ix, e)">-->
              <!--<Option v-for = "evnt in eventList"-->
              <!--:value = "evnt.eventId"-->
              <!--:key = "evnt.eventId">-->
              <!--{{evnt.eventName}}-->
              <!--</Option>-->
              <!--</Select>-->
            </FormItem>
          </i-col>
          <i-col :xs="4" :sm="4" :md="4" :lg="4" style="text-align: left">
            <FormItem :prop="'items.' + ix + '.expiryDate'"
                      :rules="{required: true, message: 'Expiry Date can not be empty', trigger: 'blur'}">
              <Input :value="licenseItem.expiryDate && licenseItem.expiryDate.split('T')[0]"
                     @input="(val) => validateDate(val, ix)" type="date">
              </Input>
            </FormItem>
          </i-col>
          <i-col :xs="2" :sm="2" :md="2" :lg="2" style="text-align: center">
            <Icon type="ios-close-circle-outline" color="#9b3035" title="Delete License" size="24"
                  @click="handleRemove(licenseItem, ix)"/>
          </i-col>
        </FormItem>
        <FormItem>
          <br/>
          <i-col :xs="24" :sm="24" :md="24" :lg="24" style="text-align: right">
            <Button size="large" type="primary" @click="handleAdd">Add License</Button>
          </i-col>
        </FormItem>
      </Form>
      <div slot="footer" id="dvFooter">
        <Button size="large" @click="handleReset;showFormModal=false" style="margin-left: 8px">
          Cancel
        </Button>
        <Button size="large" class="submit" type="success" v-if="action=='edit'"
                @click="handleUpdate">
          Save
        </Button>
      </div>
    </Modal>
    <Modal v-model="confirmLogOut" title="CONFIRMATION" @on-ok="logOutLicense(logOutIndex)"
           ok-text="Continue" class-name="vertical-center-modal card-modal" :width="480">
      <div class="confirmation-body">
        <p>
          <Icon type="md-help-circle" size="24" color="#f90"/>
          <span>{{logOutMessage}}</span></p>
      </div>
      <div slot="footer">
        <Button size="large" @click="confirmLogOut=false">Cancel</Button>
        <Button size="large" class="submit" type="error"
                @click="logOutLicense(logOutIndex);confirmLogOut=false">Log Out
        </Button>
      </div>
    </Modal>
    <Modal v-model="confirmDelete" title="CONFIRMATION" @on-ok="remove_License(deleteIndex)"
           ok-text="Continue" class-name="vertical-center-modal card-modal" :width="480">
      <div class="confirmation-body">
        <p>
          <Icon type="md-help-circle" size="24" color="#f90"/>
          <span>{{deleteMessage}}</span></p>
        <p class="submessage">*all associated data will be erased</p>
      </div>
      <div slot="footer">
        <Button size="large" @click="confirmDelete=false">Cancel</Button>
        <Button size="large" class="submit" type="error"
                @click="remove_License(deleteIndex);confirmDelete=false">Delete
        </Button>
      </div>
    </Modal>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import {addLicense, deleteLicense, getLicenses, updateLicense} from '../../services/Licenses.service'
  import {licenseLogout} from '../../services/Authentication.service'
  import {getCompanyById} from '../../services/Companies.service'
  import {getEvents} from '../../services/Events.service'
  import moment from 'moment-timezone'
  import {bus} from '../../main'

  export default {
    components: {},
    data() {
      return {
        deleteIndex: null,
        confirmDelete: false,
        deleteMessage: '',
        logOutIndex: null,
        confirmLogOut: false,
        logOutMessage: '',
        companyId: null,
        events: null,
        eventList: [],
        result: null,
        index: 0,
        action: 'Add',
        title: 'ADD',
        showFormModal: false,
        companyName: null,
        companyLicenseForm: {
          items: [{
            licenseId: null,
            licenseKey: null,
            licenseLabel: null,
            companyId: null,
            eventId: null,
            isUsed: false,
            expiryDate: null,
            deviceType: null,
            updatedBy: null,
            updatedDate: null,
            createdBy: null,
            createdDate: null,
            deleted: false,
            deletionDate: null
          }]
        },
        indeterminate: null,
        checkAll: false,
        ruleValidate: {
          eventId: [
            {required: true, message: 'Event cannot be empty', trigger: 'blur'}
          ],
          expiryDate: [
            {required: true, message: 'Expiry Date cannot be empty', trigger: 'blur'}
          ]
        },
        spinnerShowLicense: true,
        dataCompanyCount: 0,
        pageCompanySizer: [10, 25, 50, 100],
        pageCompanySize: 10,
        historyCompanyData: [],
        showCompanyPager: false,
        showAllLicences: false,
        eventNames: []
      }
    },
    computed: {
      ...mapGetters(['getUserDetails', 'getAdminUser']),
      ...mapGetters(['getEvent', 'getEventList']),
      ...mapGetters(['getCompanyDetail', 'getCompanyListDetail']),
      ...mapGetters(['getLicenseDetail', 'getLicenseListDetail']),
    },
    methods: {
      ...mapActions(['setUserDetails', 'setAdminUser']),
      ...mapActions(['setEvent', 'setEventList']),
      ...mapActions(['setCompanyDetail', 'setCompanyListDetail']),
      ...mapActions(['setLicenseDetail', 'setLicenseListDetail']),

      filterMethod(value, option) {
        let _value = value ? value.toUpperCase() : '';
        let _option = option ? option.toUpperCase() : '';
        return _option.indexOf(_value) !== -1;
      },

      openLicenseForm(title, action) {
        this.handleReset();
        this.showFormModal = true;
        this.spinnerShowLicense = true;
        this.title = title;
        this.action = action;
      },
      setFormValue(companyId) {
        const self = this;
        self.companyId = companyId;
        self.eventList = [];
        self.companyLicenseForm.items = [];
        self.eventNames = [];
        self.spinnerShowLicense = true;
        var evtIds = [];

        getCompanyById(companyId).then(company => {
          this.companyName = company.data.companyName;
          getEvents(true).then(result => {
            self.events = result.data;
            console.log(company.data.eventIds)
            if (company.data.eventIds) {
              company.data.eventIds.forEach(function (id) {
                let event = result.data.filter(a => a.eventId === id)[0];
                if (event != null && event.deleted === false) {
                  self.eventList.push(event.eventName);
                }
              })
            }

            getLicenses(false, companyId).then(response => {
              response.data.map(a => {
                if (!a.licenseLabel) {
                  a.licenseLabel = a.licenseKey;
                }
              });

              response.data
                .sort((a, b) => (moment(b.expiryDate) - moment(a.expiryDate)))
                .sort((a, b) => (a.eventId > b.eventId) ? 1 : ((b.eventId > a.eventId) ? -1 : 0))
                .sort((a, b) => (a.isUsed < b.isUsed) ? 1 : ((b.isUsed < a.isUsed) ? -1 : 0));

              var dateNow = moment(new Date()).format('YYYY-MM-dd');

              if (!self.showAllLicences) {
                self.companyLicenseForm.items = response.data
                  .filter(a => a.licenseKey.toUpperCase())
                  .filter(a => (moment(a.expiryDate).format('YYYY-MM-dd')) > dateNow);
              } else {
                self.companyLicenseForm.items = response.data
                  .filter(a => a.licenseKey.toUpperCase());
              }

              self.spinnerShowLicense = false;

              self.historyCompanyData = self.companyLicenseForm.items;
              self.dataCompanyCount = self.companyLicenseForm.items.length;
              if (self.historyCompanyData.length < self.pageCompanySize) {
                self.companyLicenseForm.items = self.historyCompanyData;
                evtIds = self.companyLicenseForm.items.map(function (a) {
                  if (a.eventId != null) {
                    return a.eventId;
                  } else return 0;
                });
              } else {
                self.companyLicenseForm.items = self.historyCompanyData.slice(0, self.pageCompanySize);
                evtIds = self.companyLicenseForm.items.map(function (a) {
                  if (a.eventId != null) {
                    return a.eventId;
                  } else return 0;
                });
              }
              if (self.companyLicenseForm.items.length > 0) {
                self.showCompanyPager = true;
              }
              evtIds.forEach(function (id) {
                let event = result.data.filter(a => a.eventId === id)[0];
                if (event != null) {
                  self.eventNames.push(event.eventName);
                }
                if (id == 0) {
                  self.eventNames.push('');
                }
              });
            });

          });
        });
      },
      handleUpdate() {
        const self = this;
        self.$refs['companyLicenseForm'].validate((valid) => {
          if (valid) {
            self.historyCompanyData.forEach(function (item, i) {
              var evt = self.events.filter(a => a.eventName === self.eventNames[i] && a.deleted === false);
              if (evt != null) {
                item.eventId = evt[0].eventId;
              }

              if (item.licenseId > 0) {
                updateLicense(item.licenseId, item)
                  .then(response => {
                    self.$emit('updateLicense', item.licenseId, item);
                    self.showFormModal = false;
                    bus.$emit('reloadAdminData');
                  })
                  .catch(error => {
                    if (error.response.request.responseText) {
                      let errResponse = JSON.parse(error.response.request.responseText)
                      Object.keys(errResponse).map(key => {
                        errResponse[key].map(errMsg => {
                          self.$Message.error(errMsg);
                        })
                      })
                    } else {
                      self.$Message.error('Failed updating License ' + error);
                    }
                  })
              } else {
                addLicense(item)
                  .then(response => {
                    self.$emit('addLicense', item);
                    self.showFormModal = false;
                    bus.$emit('reloadAdminData');
                  })
                  .catch(error => {
                    if (error.response.request.responseText) {
                      let errResponse = JSON.parse(error.response.request.responseText)
                      Object.keys(errResponse).map(key => {
                        errResponse[key].map(errMsg => {
                          self.$Message.error(errMsg);
                        })
                      })
                    } else {
                      self.$Message.error('Failed updating License ' + error);
                    }
                  })
              }
            });
          }
        });
      },
      handleReset() {
        let self = this;
        Object.keys(this.companyLicenseForm.items).forEach(function (key, i) {
          self.companyLicenseForm.items[key] = '';
        });
        self.spinnerShowLicense = false;
        self.dataCompanyCount = 0;
        self.pageCompanySizer = [10, 25, 50, 100];
        self.pageCompanySize = 10;
        self.historyCompanyData = [];
        self.showCompanyPager = false;
        self.showAllLicences = false;
      },
      handleRemove(obj, ix) {
        this.deleteIndex = ix;
        this.confirmDelete = true;
        this.deleteMessage = `Are you sure you want to delete "${obj.licenseKey}"?`;
      },
      remove_License(index) {
        const self = this;
        let obj = null;
        if (this.companyLicenseForm.items) {
          obj = this.companyLicenseForm.items[index];
          if (obj.licenseId > 0) {
            //first log out
            if (obj.isUsed) {
              licenseLogout(obj.licenseKey).then((response) => {
                //then delete
                deleteLicense(obj.licenseId, true).then(response => {
                  self.eventNames.splice(index, 1);
                  this.$emit('deleteLicense', obj.licenseId, true);
                  this.$Message.success('License successfully deleted!');
                  this.companyLicenseForm.items.splice(index, 1);

                }).catch(error => {
                  this.$Message.error('Failed deleting License ' + error);
                });
              });
            } else {
              //then delete
              deleteLicense(obj.licenseId, true).then(response => {
                this.$emit('deleteLicense', obj.licenseId, true);
                this.$Message.success('License successfully deleted!');
                this.companyLicenseForm.items.splice(index, 1);
                self.eventNames.splice(index, 1);
              }).catch(error => {
                this.$Message.error('Failed deleting License ' + error);
              });
            }
          } else {
            this.companyLicenseForm.items.splice(index, 1);
            self.eventNames.splice(index, 1);
          }
        }
      },
      handleAdd() {
        const self = this;
        let startDate = new Date();
        var evtIds = [];
        var limit = 0, cut = 0;
        let endDateMoment = moment(startDate).add(3, 'months').toISOString();
        let newRow = {
          licenseId: 0,
          licenseKey: this.uuid(),
          licenseLabel: '',
          companyId: this.companyId,
          eventId: this.eventList[0].eventId,
          isUsed: false,
          expiryDate: endDateMoment,
          deviceType: null,
          updatedBy: null,
          updatedDate: null,
          createdBy: null,
          createdDate: null,
          deleted: false,
          deletionDate: null,
        };
        newRow.licenseLabel = newRow.licenseKey;
        limit = self.historyCompanyData.length;
        cut = self.companyLicenseForm.items.length;
        if (!self.companyLicenseForm.items) {
          self.companyLicenseForm.items = [];
        }
        //self.companyLicenseForm.items.push(newRow);

        //re-organize
        self.historyCompanyData.push(newRow);
        self.dataCompanyCount = self.historyCompanyData.length;
        if (self.historyCompanyData.length <= 10) {
          self.pageCompanySize = 10;
        }
        if (self.historyCompanyData.length > 10 && self.historyCompanyData.length <= 25) {
          self.pageCompanySize = 25;
        }
        if (self.historyCompanyData.length > 25 && self.historyCompanyData.length <= 50) {
          self.pageCompanySize = 50;
        }
        if (self.historyCompanyData.length > 50 && self.historyCompanyData.length <= 100) {
          self.pageCompanySize = 100;
        }

        if (self.historyCompanyData.length < self.pageCompanySize) {
          self.companyLicenseForm.items = self.historyCompanyData;
          evtIds = self.companyLicenseForm.items.map(function (a) {
            if (a.eventId != null) {
              return a.eventId;
            } else return 0;
          });
        } else {
          self.companyLicenseForm.items = self.historyCompanyData.slice(0, self.pageCompanySize);
          evtIds = self.companyLicenseForm.items.map(function (a) {
            if (a.eventId != null) {
              return a.eventId;
            } else return 0;
          });
        }
        for (var i = cut; i < limit; i++) {
          let event = self.events.filter(a => a.eventId === evtIds[i])[0];
          if (event != null) {
            self.eventNames.push(event.eventName);
          }
        }
        // evtIds.forEach(function (id) {
        //   let event = JSON.parse(localStorage.getItem('events')).filter(a => a.eventId === id)[0];
        //   if (event != null) {
        //     self.eventNames.push(event.eventName);
        //   }
        // });
      },
      validateDate(val, ix) {
        let valid1 = false;
        let valid2 = false;

        // regular expression to match required date format
        let regExp1 = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/; //MM/dd/yyyy
        let regExp2 = /^(\d{4})\-(\d{1,2})\-(\d{1,2})$/; //yyyy-mm-dd

        valid1 = val.match(regExp1);
        valid2 = val.match(regExp2);

        if (valid1 || valid2) {
          this.companyLicenseForm.items[ix].expiryDate = val;
        } else {
          this.companyLicenseForm.items[ix].expiryDate = null;
        }
      },
      changeEvents(ix, id) {
        this.companyLicenseForm.items[ix].eventId = id;
      },
      getTimeStamp() {
        let length = 8;
        let timestamp = +new Date;
        let _getRandomInt = function (min, max) {
          return Math.floor(Math.random() * (max - min + 1)) + min;
        };
        let ts = timestamp.toString();
        let parts = ts.split("").reverse();
        let id = "";
        for (let i = 0; i < length; ++i) {
          let index = _getRandomInt(0, parts.length - 1);
          id += parts[index];
        }
        return id;
      },
      openLogOut(index) {
        this.logOutIndex = index;
        this.confirmLogOut = true;
        let key = this.companyLicenseForm.items[index].licenseKey;
        this.logOutMessage = `Are you sure you want to log out "${key}"?`;
      },
      logOutLicense(ix) {
        let item = this.companyLicenseForm.items[ix];
        licenseLogout(item.licenseKey).then((response) => {
          this.companyLicenseForm.items[ix].isUsed = false;
          this.$Message.success('License successfully logged out.');
        }).catch(error => {
          this.$Message.error('Failed logging out License ' + error);
        });
      },
      changeCompanyPageSize(size) {
        this.pageCompanySize = size;
        this.changeSelectedCompanyPage(1);
      },
      changeSelectedCompanyPage(index) {
        const self = this;
        self.eventNames = [];
        let _start = (index - 1) * this.pageCompanySize;
        let _end = index * this.pageCompanySize;
        this.companyLicenseForm.items = this.historyCompanyData.slice(_start, _end);
        let evtIds = this.companyLicenseForm.items.map(function (a) {
          if (a.eventId != null) {
            return a.eventId;
          } else return 0;
        });
        evtIds.forEach(function (id) {
          let event = self.events.filter(a => a.eventId === id)[0];
          if (event != null) {
            self.eventNames.push(event.eventName);
          }
          if (id == 0) {
            self.eventNames.push(' ');
          }
        });
      },
      uuid() {
        // return 'xxxxxx'.replace(/[xy]/g, function (c) {
        //   var r = Math.random() * 6 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        //   return v.toString(6);
        // });
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

        for (var i = 0; i < 6; i++)
          text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
      },
      licenseLabelCheck(e, ix) {
        let val = e.target.value;
        let list = this.companyLicenseForm.items.filter(a => a.licenseLabel === val);
        if (list.length > 1) {
          e.preventDefault();
          e.stopPropagation();
          setTimeout(() => {
            this.companyLicenseForm.items[ix].licenseLabel = null;
            this.$Message.error('label is used already!');
          }, 300);
          return false;
        }
      }
    }
  }
</script>

<style scoped>

  .ico {
    color: #35bc44;
    background-color: #fff;
    font-size: 1.1vw;
  }

  .ico:hover {
    cursor: pointer;
  }

  .ico:active {
    opacity: 0.7;
    transform: translateY(1px);
  }

  .greenMark {
    color: #fff;
    background-color: #35bc44;
    border-radius: 5px;
    cursor: pointer;
  }

  .grayMark {
    color: #fff;
    background-color: #6f6f70;
    border-radius: 5px;
    cursor: not-allowed;
  }

  .ivu-form-item {
    margin-bottom: 1px
  }

  .ivu-form-item:nth-child(even) {
    background: #efefef;
  }

  .ivu-form-item:nth-child(odd) {
    background: #ffffff;
  }

  .ivu-form-item:nth-child(even) .ico {
    background: transparent;
    cursor: initial;
  }

  .ivu-form-item:nth-child(odd) .ico {
    background: transparent;
    cursor: initial;
  }

  .card-modal .ivu-modal-body .ivu-col {
    padding: 0;
  }

  .full-input {
    border: 0;
    padding: 0;
  }

  #dvFooter {
    text-align: center;
  }

  .red-star {
    color: red;
  }

</style>



// WEBPACK FOOTER //
// src/components/k_globalAdministration/companyLicenseForm.vue